import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../../localization/messages";
import { AccountActionCreators } from "../../../../redux/action-creators";
import { useDispatch } from "react-redux";
import { DrawerActionType } from "../../../ControlCenter";
import { DrawerType } from "../../../../constants/";
import {
  MyAccountAreaHeaderWrapper,
  Title,
  AreaHeaderTitle,
  AreaHeaderCloseIcon
} from "./myAccountAreaHeaderWrapper";
import { useTheme } from "styled-components";
import SVGIconV3 from "../../../common/SVGIcon/SVGIconV3";

const MyAccountAreaHeader = props => {
  const { drawerType } = props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const [title, setTitle] = useState(null);

  useEffect(() => {
    const drawerOptions = {
      [DrawerType.MyAccountArea]: LocalizationMessages.MyAccountAreaHeaderTitle
    };
    const _title = drawerOptions[drawerType] ? drawerOptions[drawerType] : "";
    setTitle(_title);
  }, [drawerType]);
  const onClose = () => {
    const drawerOptions = {
      [DrawerType.MyAccountArea]: () => {
        dispatch(
          AccountActionCreators.toggleAccountDrawer(DrawerActionType.UserArea)
        );
      }
    };
    drawerOptions[drawerType] ? drawerOptions[drawerType]() : null;
  };

  return (
    <MyAccountAreaHeaderWrapper>
      {title && (
        <AreaHeaderTitle>
          <Title>
            <FormattedMessage {...title} />
          </Title>
        </AreaHeaderTitle>
      )}
      <AreaHeaderCloseIcon
        onClick={onClose}
        data-testid="uc-my-account-area-header-close"
      >
        <SVGIconV3
          iconName="close"
          data-testid="uc-close-menu-icon"
          height="1.8rem"
          width="1.8rem"
          hoverColor={theme.colors.brandColor}
        ></SVGIconV3>
      </AreaHeaderCloseIcon>
    </MyAccountAreaHeaderWrapper>
  );
};

MyAccountAreaHeader.propTypes = {
  drawerType: PropTypes.string
};
export default React.memo(MyAccountAreaHeader);
